import { Alert, Button, Collapse, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { VerifyImageLoading } from "../add-image";

interface AllertMessageProps {
  message: string[];
}
export const AllertMessage = ({ message }: AllertMessageProps) => {
  const [open, setOpen] = useState(true);

  return (
    <Box sx={{ 
        width: "90%",
        margin: "auto", }}>
      <Collapse in={open}>
        <Alert
        severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {message.map((item, index) => (
            <p key={index}>{item}</p>
          ))}
        </Alert>
      </Collapse>
      <Button
        disabled={open}
        variant="outlined"
        onClick={() => {
          setOpen(true);
        }}
    
      >
        Re-open
      </Button>
    </Box>
  );
};
